module.exports = __webpack_public_path__ + "img/bannerImg.76c58fad.png";